"use client";

import React, { useEffect, useState } from "react";

import styles from "./CitySelector.module.scss";
import CitySelectionModal from "../CitySelectionModal";
import Button from "@components/atoms/Button";
import Image from "@components/atoms/Image";
import assetLoader from "@utils/internalImageLoder";
import { getSelectedCityClient } from "@helpers/client/getSelectedCity";
import { getPageNameFromUrl } from "@utils/pageNameUtils";
import { usePathname } from "next/navigation";
import { useCity } from "@context/CityContext";

export default function CitySelector({ showIcon, withPencilIcon, pageType }: any) {
  const pathname = usePathname();
  const { city: contextCity } = useCity();
  const [city, setCity] = useState<any>(null);

  useEffect(() => {
    const selected = getSelectedCityClient();
    setCity(selected);
  }, []);

  // Update local city state when context city changes
  useEffect(() => {
    if (contextCity) {
      const selected = getSelectedCityClient();
      setCity(selected);
    }
  }, [contextCity]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);

  return (
    <>
      {showIcon && (
        <Button
          className={`${styles.headerIcon} ${withPencilIcon ? styles.withPencilIconButton : ""
            }`}
          onButtonClick={() => openModal()}
          type="button"
          segmentEventProps={{
            eventName: "action",
            pageType: pageType,
            eventProperties: {
              action_type: "tap_btn",
              action_name: "tap_btn_cities",
              city_name: city?.name,
            },
          }}
        >
          <span className={withPencilIcon ? styles.name : ""}>
            {city?.name}
          </span>
          <Image
            src={
              withPencilIcon
                ? `${assetLoader()}/icons/EditArrow.svg`
                : `${assetLoader()}/icons/CitySelection/Chevron_down_grey.svg`
            }
            alt="Select"
            width={16}
            height={16}
            className={styles.cityChevronIcon}
          />
        </Button>
      )}

      {isModalOpen && (
        <CitySelectionModal
          selectedCity={city}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
        />
      )}
    </>
  );
}
